"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectExploded = exports.SelectExplodedField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var React = __importStar(require("react"));
var FlexView_1 = require("../../../../FlexView");
var Form_1 = require("../../../Form");
var fieldMaker_1 = require("../../fieldMaker");
var pullValue_1 = require("../utility/pullValue");
var pushValue_1 = require("../utility/pushValue");
var resultDataBuilder_1 = require("../utility/resultDataBuilder");
var SelectExplodedField = /** @class */ (function (_super) {
    __extends(SelectExplodedField, _super);
    function SelectExplodedField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeChoiceOption = function (option) { return function (value, flaged) {
            if (!_this.props.onChange) {
                return;
            }
            var newValue = flaged
                ? (0, pushValue_1.pushValue)(option, _this.props.value, _this.props.multiple, _this.props.forcedValue)
                : (0, pullValue_1.pullValue)(option, _this.props.value);
            _this.props.onChange(newValue, (0, resultDataBuilder_1.resultDataBuilder)(newValue, _this.props.options));
        }; };
        return _this;
    }
    SelectExplodedField.prototype.valueIsSelectExploseed = function (value) {
        if (!this.props.value || (Array.isArray(this.props.value) && this.props.value.length === 0)) {
            return 'none';
        }
        if (Array.isArray(this.props.value)) {
            return Array.from(this.props.value).filter(function (currentValue) { return currentValue === value; }).length !== 0
                ? 'selected'
                : 'notSelected';
        }
        return this.props.value === value ? 'selected' : 'notSelected';
    };
    SelectExplodedField.prototype.render = function () {
        var _this = this;
        if (Array.isArray(this.props.value) && !this.props.multiple) {
            throw new Error('with multiple you cant use array as value');
        }
        return ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ gutters: { tb: 'xs', lr: this.props.inline ? 'xs' : 'none' }, className: this.props.className }, { children: this.props.options &&
                this.props.options.map(function (option) { return ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: _this.props.inline ? undefined : 12 }, { children: (0, jsx_runtime_1.jsx)(Form_1.Form.ChoiceOption, { name: _this.props.name, label: option.label, theme: _this.valueIsSelectExploseed(option.value) === 'none' ? 'blue' : 'default', type: _this.props.multiple ? 'checkbox' : 'radio', value: _this.valueIsSelectExploseed(option.value) === 'selected' ? 1 : 0, onChange: _this.onChangeChoiceOption(option), disabled: option.disabled || _this.props.disabled }) }), option.value)); }) })));
    };
    return SelectExplodedField;
}(React.PureComponent));
exports.SelectExplodedField = SelectExplodedField;
exports.SelectExploded = (0, fieldMaker_1.makeField)(SelectExplodedField);
//# sourceMappingURL=SelectExploded.js.map